<div class="yopa-logo" [class.associates-logo]="isAssociatesRoute$ | async">
  YOPA
</div>
